
import apiMiddleware from '../api/apiMiddleware';

export const login = async (credentials) => {
  const response = await apiMiddleware.post(
    "/auth/login/supplier",
    credentials
  );
  return response.data;
};

export const register = async (formData) => {
  const response = await apiMiddleware.post("/auth/register/supplier", formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Important for file uploads
    },
  });
  return response;
};
